












import Vue from "vue";
import Separator from "@/components/Separator.vue";
import { mapActions, mapMutations } from "vuex";
import { AxiosResponse } from "axios";

export default Vue.extend({
  name: "InvitePage",
  components: {
    Separator,
  },
  created() {
    const token = this.$route.query.token;

    this.fetchTokenInfo({ token })
      .then((response: AxiosResponse) => {
        const { email, exists } = response.data;

        // 2. If the user exists, direct them to login, else they must register
        // Tokens are processed after Logging In or Registering
        if (exists) {
          this.$router.replace({
            name: "login",
            query: { token, email },
          });
        } else {
          this.$router.replace({
            name: "register",
            query: { token, email },
          });
        }
      })
      .catch((e: AxiosResponse) => {
        this.toastError(e.data);
        this.$router.replace({
          name: "login",
        });
      });
  },
  methods: {
    ...mapActions("auth", ["fetchTokenInfo", "logout"]),
    ...mapMutations("snackbar", ["toastError"]),
  },
});
